var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgShieldLogo = function SvgShieldLogo(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 80,
    viewBox: "0 0 72 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.8125 9.53125C53.2256 9.53125 37.2909 0.709531 37.1306 0.6225L36 0L34.8694 0.6225C34.7091 0.709531 18.7744 9.53125 3.1875 9.53125H0.84375V11.875C0.84375 69.2373 33.9516 79.4209 35.3614 79.8192L36 80L36.6386 79.8192C38.0484 79.4209 71.1562 69.2373 71.1562 11.875V9.53125H68.8125Z",
    fill: "#EFF1F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1562 11.875V9.53125H68.8125C53.2256 9.53125 37.2909 0.709531 37.1306 0.6225L36 0V80L36.6386 79.8192C38.0484 79.4209 71.1562 69.2373 71.1562 11.875Z",
    fill: "#E9EAEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0012 5.32373C32.1514 7.28295 19.2173 13.5069 5.55078 14.1615C6.32906 62.1581 31.4923 73.4837 36.0012 75.0973C40.5102 73.4837 65.6734 62.158 66.4517 14.1615C52.7852 13.5069 39.8511 7.28295 36.0012 5.32373Z",
    fill: "#559A26"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4505 14.1615C52.7839 13.5069 39.8498 7.28295 36 5.32373V75.0973C40.5089 73.4837 65.6722 62.1581 66.4505 14.1615Z",
    fill: "#6BAF3C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36 14.2188C24.3752 14.2188 14.9062 23.6877 14.9062 35.3125C14.9062 46.9373 24.3752 56.4062 36 56.4062C47.6248 56.4062 57.0938 46.9373 57.0938 35.3125C57.0938 23.6877 47.6248 14.2188 36 14.2188Z",
    fill: "#EFF1F4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0938 35.3125C57.0938 46.9373 47.6248 56.4062 36 56.4062V14.2188C47.6248 14.2188 57.0938 23.6877 57.0938 35.3125Z",
    fill: "#E9EAEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7187 28.968L36.0008 36.6858L33.657 39.0296L28.2828 33.6555L24.9688 36.9696L33.657 45.658L36.0008 43.3143L47.0328 32.2821L43.7187 28.968Z",
    fill: "#559A26"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.032 32.2821L43.718 28.968L36 36.6858V43.3143L47.032 32.2821Z",
    fill: "#6BAF3C"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgShieldLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/shield-logo.92b4c3dc.svg";